export const SHEET_STYLES = {
  overlay:
    "fixed inset-0 z-[60] bg-black/40 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
  content:
    "fixed z-[60] gap-4 bg-background p-6 shadow-xl transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500 scrollbar-hide overflow-y-auto",

  contentTop:
    "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
  contentBottom:
    "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
  contentLeft:
    "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
  contentRight:
    "inset-y-0 right-0 h-full border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right",

  sizesSm: "w-[400px] max-w-[90vw]",
  sizesMd: "w-[500px] max-w-[90vw]",
  sizesLg: "w-[600px] max-w-[90vw]",
  sizesXl: "w-[70vw] max-w-[800px]",
  sizesFull: "w-[95vw]",

  mobileFullScreen:
    "inset-0 data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
  mobileLeft:
    "inset-y-0 left-0 h-full w-[85vw] max-w-md border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left",
  mobileRight:
    "inset-y-0 right-0 h-full w-[85vw] max-w-md border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right",
  mobileBottom:
    "inset-x-0 bottom-0 h-[90vh] max-h-[90vh] rounded-t-3xl data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",

  closeButton:
    "absolute text-ticketon-lighter-blue z-10 bg-white hover:bg-gray-100 right-4 top-4 shadow-ticketon-card p-2 border-ticketon-light-gray-bg border rounded-full transition-opacity hover:ticketon-lighter-blue disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground focus:outline-none focus-visible:outline-none focus:ring-0",
  header: "flex flex-col space-y-2",
  footer: "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
  title: "text-[24px] font-bold text-ticketon-lighter-blue leading-none tracking-tight",
  description: "text-sm text-muted-foreground",
} as const;
